import React from 'react';

const SvgClose = props => (
  <svg viewBox="0 0 64 64" {...props}>
    <path
      d="M47.414 47.435a2.001 2.001 0 0 1-2.83 0l-12.6-12.6-12.589 12.59a2.002 2.002 0 0 1-2.83-2.831l12.588-12.589L16.567 19.42a2.001 2.001 0 0 1 2.83-2.83l12.587 12.586L44.58 16.577a2.001 2.001 0 1 1 2.83 2.83L34.815 32.006l12.6 12.6a2.001 2.001 0 0 1 0 2.83z"
      fillRule="evenodd"
    />
  </svg>
);

export default SvgClose;
